import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Switch, FormControlLabel, Box } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';

// Styled Switch component
const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: '62px',
  height: '36px',
  padding: 0,
  overflow: 'visible',
  '& .MuiSwitch-switchBase': {
    padding: 4,
    '&.Mui-checked': {
      transform: 'translateX(26px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#1a202c',
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: '#ffffff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 28,
    height: 28,
    backgroundColor: '#ffffff',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
    transition: theme.transitions.create(['width', 'transform'], {
      duration: 300,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 36 / 2,
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? '#1a202c' : '#e2e8f0',
    boxSizing: 'border-box',
    transition: theme.transitions.create(['background-color'], {
      duration: 300,
    }),
  },
}));

// ThemeSwitch component with icons
const ThemeSwitch = ({ checked, onChange, label = '', ...props }) => {
  return (
    <FormControlLabel
      control={
        <Box sx={{ position: 'relative' }}>
          <StyledSwitch checked={checked} onChange={onChange} {...props} />
          <LightModeIcon
            sx={{
              position: 'absolute',
              left: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '18px',
              color: checked ? 'rgba(255, 255, 255, 0.6)' : '#ff9800',
              transition: 'color 0.3s',
              pointerEvents: 'none',
            }}
          />
          <DarkModeIcon
            sx={{
              position: 'absolute',
              right: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '18px',
              color: checked ? 'background.default' : 'rgba(0, 0, 0, 0.3)',
              transition: 'color 0.3s',
              pointerEvents: 'none',
            }}
          />
        </Box>
      }
      label={label}
      sx={{ m: 0 }}
    />
  );
};

ThemeSwitch.propTypes = {
  /**
   * If true, the switch is in dark mode.
   */
  checked: PropTypes.bool.isRequired,
  /**
   * Callback fired when the state is changed.
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Optional label for the switch.
   */
  label: PropTypes.string,
};

export default ThemeSwitch;
